import * as types from '../types';

const demoExercises = window.demoExercises || [];

function exercises(state = {
  isFetching: false,
  hasSaved: false,
  hasUpdated: false,
  exercises: demoExercises || [],
  activeExercise: null,
  errors: [],
}, action) {
  switch (action.type) {
  case types.EXERCISE_REQUEST:
    return { ...state,
        isFetching: true,
      };

  case types.EXERCISE_SUCCESS:
    return { ...state,
        isFetching: false,
        exercises: action.response,
      };

  case types.EXERCISE_FAILURE:
    return { ...state,
        isFetching: false,
      };
  case types.EXERCISE_CREATE_REQUEST:
    return { ...state,
        isFetching: true,
        hasSaved: false,
      };

  case types.EXERCISE_CREATE_SUCCESS:
    {
      const newExercises = [...state.exercises];
      newExercises.push(action.response);
      return { ...state,
          isFetching: false,
          hasSaved: true,
          exercises: newExercises,
        };
    }
  case types.EXERCISE_CREATE_FAILURE:
    return { ...state,
        isFetching: false,
        hasSaved: false,
      };
  case types.EXERCISE_UPDATE_REQUEST:
    return { ...state,
        isFetching: true,
        hasUpdated: false,
        errors: [],
      };

  case types.EXERCISE_UPDATE_SUCCESS:
    {
      const newExercises = [...state.exercises];
      newExercises.forEach((item, i, array) => {
        if (item.id === action.response.id) array[i] = action.response; // eslint-disable-line no-param-reassign
      });

      return { ...state,
          isFetching: false,
          hasUpdated: true,
          exercises: newExercises,
        };
    }
  case types.EXERCISE_UPDATE_FAILURE:
    return { ...state,
        isFetching: false,
        hasUpdated: false,
        errors: action.errors,
      };
  case types.EXERCISE_DELETE_REQUEST:
    return { ...state,
        isFetching: true,
      };

  case types.EXERCISE_DELETE_SUCCESS:
    {
      const newExercises = [...state.exercises];
      newExercises.forEach((item, i, array) => {
        if (item.id === action.response.id) array.splice(i, 1);
      });

      return { ...state,
          isFetching: false,
          exercises: newExercises,
          activeExercise: null,
        };
    }
  case types.EXERCISE_DELETE_FAILURE:
    return { ...state,
        isFetching: false,
      };
  case types.LAUNCH_EXERCISE:
    return { ...state,
        activeExercise: action.activeExercise,
      };
  case types.CLEAR_EXERCISE:
    return { ...state,
        activeExercise: null,
      };
  default:
    return state;
  }
}


export default exercises;



// WEBPACK FOOTER //
// ./src/reducers/exercises.js